<template>
<TabGroup  >
  <div id="property-tabs" class="property-tabs">

    <TabList class="tab-labels">
      <Tab class="tab-label tw-border-0 tw-ui-selected:tw-text-[#3d5099] tw-ui-selected:tw-opacity-100 tw-opacity-50 tw-ui-focus-visible:tw-outline-none" v-for="tab in props.tabs" :key="tab.name" :id="'property-tabs-button-'+tab.name">
      {{ tab.title }}</Tab>

    </TabList>
    <TabPanels>
      <TabPanel v-for="tab in props.tabs" :key="tab.name" :id="'property-tabs-panel-'+tab.name">
        <div v-if="tab.type == 'images'">
          <image-gallery :images="tab.content" @start-large-carousel="showLargeCarousel"/>
        </div>
        <div v-if="tab.type == 'floorplans'">
          <image-gallery :images="tab.content" @start-large-carousel="showLargeCarousel"/>
        </div>
        <div v-if="tab.type == 'video'">
          <div class="embed-responsive">
            <iframe :src="tab.content"></iframe>
          </div>
        </div>
        <div v-if="tab.type == '360tour'">
          <div class="embed-responsive embed-360">
            <iframe :src="tab.content.url" :name="tab.content.name" width="100%" height="100%" allow="fullscreen; accelerometer; gyroscope; magnetometer; vr;"></iframe>
          </div>
        </div>
        <div v-if="tab.type == 'map'">
          <property-map :map="tab.content"/>

        </div>
      </TabPanel>
    </TabPanels>
  </div>
  </TabGroup>

</template>

<script setup>
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import ImageGallery from "../Carousels/ImageGallery.vue";
import PropertyMap from '../Maps/PropertyMap.vue';

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
  },
});

const showLargeCarousel = (id) => {
  console.log(id);
};
</script>
